const DEFAULT_WISHLIST_NAME = 'My Wishlist';

window.wishlistContents = {};

window.addToWishlist = ({variantId, productId, url}) => {
  // Ensure wishlist ID exists before trying to add items
  const performAdd = (listId) => {
    window._swat.addToList(listId, {epi: variantId, empi: productId, du: url}, (response) => {
      // Show success notification
      if (window._swat && window._swat.ui && typeof window._swat.ui.showSuccessNotification === 'function') {
        window._swat.ui.showSuccessNotification({ message: '❤️ Added to wishlist! Click again to manage.' });
      } else {
        // Fallback notification
        const notification = document.createElement('div');
        notification.className = 'swym-custom-notification swym-success';
        notification.innerHTML = '❤️ Added to wishlist! Click again to manage.';
        notification.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #4CAF50; color: white; padding: 15px 20px; border-radius: 4px; z-index: 9999; font-size: 14px;';
        document.body.appendChild(notification);
        setTimeout(() => notification.remove(), 3000);
      }
      updateWishlistButtonState(variantId, productId, true);
    }, (error) => {
      console.error('Swym wishlist error:', error);
      // Show error notification
      if (window._swat && window._swat.ui && typeof window._swat.ui.showErrorNotification === 'function') {
        window._swat.ui.showErrorNotification({ message: 'Error adding to wishlist. Please try again.' });
      } else {
        // Fallback notification
        const notification = document.createElement('div');
        notification.className = 'swym-custom-notification swym-error';
        notification.innerHTML = 'Error adding to wishlist. Please try again.';
        notification.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #f44336; color: white; padding: 15px 20px; border-radius: 4px; z-index: 9999; font-size: 14px;';
        document.body.appendChild(notification);
        setTimeout(() => notification.remove(), 3000);
      }
    });
  };

  // Check if wishlist ID already exists
  if (window._swat.swymCustomWishlistSelectedListId) {
    performAdd(window._swat.swymCustomWishlistSelectedListId);
  } else {
    // Create/get wishlist first, then add item
    window.ensureSingleWishlist(DEFAULT_WISHLIST_NAME, function(res) {
      if (res?.lid) {
        window._swat.swymCustomWishlistSelectedListId = res.lid;
        performAdd(res.lid);
      } else {
        console.error('Failed to create/get wishlist');
        // Show error notification
        const notification = document.createElement('div');
        notification.className = 'swym-custom-notification swym-error';
        notification.innerHTML = 'Unable to access wishlist. Please try again.';
        notification.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #f44336; color: white; padding: 15px 20px; border-radius: 4px; z-index: 9999; font-size: 14px;';
        document.body.appendChild(notification);
        setTimeout(() => notification.remove(), 3000);
      }
    });
  }
};

window.updateWishlistButtonState = (variantId, productId, isInWishlist = true) => {
  const wishlistButtons = document.querySelectorAll('[onclick*="addToWishlist"]');
  const idButtons = document.querySelectorAll('[id*="AddToWishlistButton"]');
  const allButtons = [...wishlistButtons, ...idButtons];
  
  allButtons.forEach(button => {
    const onclickAttr = button.getAttribute('onclick');
    
    if (onclickAttr && 
        (onclickAttr.includes(`variantId: ${variantId}`) || 
         onclickAttr.includes(`variantId: '${variantId}'`) ||
         onclickAttr.includes(`productId: ${productId}`) || 
         onclickAttr.includes(`productId: '${productId}'`))) {
      
      if (isInWishlist) {
        button.classList.add('swym-added');
        button.setAttribute('title', 'In wishlist - Click to manage');
        button.setAttribute('aria-label', 'Go to wishlist to manage this item');
        button.setAttribute('onclick', `removeFromWishlist({ variantId: ${variantId}, productId: ${productId}, url: window.location.href })`);
      } else {
        button.classList.remove('swym-added');
        button.setAttribute('title', 'Add to wishlist');
        button.setAttribute('aria-label', 'Add to wishlist');
        button.setAttribute('onclick', `addToWishlist({ variantId: ${variantId}, productId: ${productId}, url: window.location.href })`);
      }
    }
  });
};



window.removeFromWishlist = ({variantId, productId, url}) => {
  // Show notification before redirect
  if (window._swat && window._swat.ui && typeof window._swat.ui.showSuccessNotification === 'function') {
    window._swat.ui.showSuccessNotification({
      message: '💙 Redirecting to your wishlist to manage this item...'
    });
  } else {
    // Fallback notification
    const notification = document.createElement('div');
    notification.className = 'swym-custom-notification swym-info';
    notification.innerHTML = '💙 Redirecting to your wishlist to manage this item...';
    notification.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #2196F3; color: white; padding: 15px 20px; border-radius: 4px; z-index: 9999; font-size: 14px;';
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  }

  setTimeout(() => {
    window.location.href = '/pages/wishlist';
  }, 1000);
};



window.updateWishlistButtonsFromContents = (wishlistItems) => {
  if (!wishlistItems || !Array.isArray(wishlistItems)) return;
  
  const inWishlistSet = new Set();
  wishlistItems.forEach(item => {
    if (item.variantId) inWishlistSet.add(String(item.variantId));
    if (item.productId) inWishlistSet.add(String(item.productId));
  });
  
  const wishlistButtons = document.querySelectorAll('[onclick*="addToWishlist"]');
  const idButtons = document.querySelectorAll('[id*="AddToWishlistButton"]');
  const allButtons = [...wishlistButtons, ...idButtons];
  
  allButtons.forEach(button => {
    const onclickAttr = button.getAttribute('onclick');
    if (!onclickAttr) return;
    
    const variantMatch = onclickAttr.match(/variantId:\s*['"]*(\d+)['"]*/) || onclickAttr.match(/variantId:\s*(\d+)/);
    const productMatch = onclickAttr.match(/productId:\s*['"]*(\d+)['"]*/) || onclickAttr.match(/productId:\s*(\d+)/);
    
    if (variantMatch || productMatch) {
      const variantId = variantMatch ? variantMatch[1] : null;
      const productId = productMatch ? productMatch[1] : null;
      const isInWishlist = (variantId && inWishlistSet.has(variantId)) || (productId && inWishlistSet.has(productId));
      
      if (isInWishlist) {
        button.classList.add('swym-added');
        button.setAttribute('title', 'In wishlist - Click to manage');
        button.setAttribute('aria-label', 'Go to wishlist to manage this item');
      } else {
        button.classList.remove('swym-added');
        button.setAttribute('title', 'Add to wishlist');
        button.setAttribute('aria-label', 'Add to wishlist');
      }
    }
  });
};

window.fetchWishlistContents = (listId) => {
  const onWishlistLoaded = (details) => {
    window.wishlistContents = details.items.map(item => ({
      name: item?.dt,
      price: item?.pr,
      image: item?.iu,
      url: item?.du,
      variantId: item?.epi,
      productId: item?.empi
    }));
    
    updateWishlistButtonsFromContents(window.wishlistContents);
    renderWishlistItems(window.wishlistContents);
  };

  window._swat.fetchListDetails({
    lid: listId
  }, onWishlistLoaded, () => {});
};

window.renderWishlistItems = (items) => {
  const container = document.getElementById('account-wishlist-render-container');
  if (!container) return;
  
  const displayItems = items.slice(0, 5);
  
  if (displayItems.length === 0) {
    container.innerHTML = '<div class="tw-text-center tw-py-8"><p class="tw-text-gray-600">No items in wishlist</p></div>';
    return;
  }
  
  const itemsHtml = displayItems.map(item => {
    const productName = item.name || 'Product';
    const productPrice = item.price ? window.Shopify.formatMoney(item.price * 100) : 'Price not available';
    const productImage = item.image || '';
    const productUrl = item.url || '#';
    const nameParts = productName.split(/\n|\r\n|\r/);
    const title = nameParts[0] || productName;
    const subtitle = nameParts[1] || '';
    
    return `
      <div class="tw-text-center">
        <a href="${productUrl}" class="tw-block">
          <div class="tw-bg-gray-200 tw-aspect-square tw-mb-4 tw-flex tw-items-center tw-justify-center tw-overflow-hidden">
            ${productImage ? 
    `<img src="${productImage}" alt="${title}" class="tw-w-full tw-h-full tw-object-cover">` : 
    '<span class="tw-text-gray-500">Product Image</span>'
}
          </div>
          <h3 class="tw-font-medium tw-text-gray-900 tw-mb-1">${title}</h3>
          ${subtitle ? `<p class="tw-text-gray-900 tw-mb-1">${subtitle}</p>` : ''}
          <p class="tw-text-gray-900">${productPrice}</p>
        </a>
      </div>
    `;
  }).join('');
  
  container.innerHTML = `<div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">${itemsHtml}</div>`;
};

window.updateProductFormWishlistButton = () => {
  const variantInput = document.querySelector('.product-variant-id');
  const wishlistButton = document.querySelector('[id*="AddToWishlistButton"]');
  
  if (!variantInput || !wishlistButton) return;
  
  const currentVariantId = variantInput.value;
  if (!currentVariantId) return;
  
  const onclickAttr = wishlistButton.getAttribute('onclick');
  const productMatch = onclickAttr ? onclickAttr.match(/productId:\s*['"]*(\d+)['"]*/) : null;
  const productId = productMatch ? productMatch[1] : null;
  
  if (!productId) return;
  
  const newOnclick = `addToWishlist({ variantId: ${currentVariantId}, productId: ${productId}, url: window.location.href })`;
  wishlistButton.setAttribute('onclick', newOnclick);
  
  if (window.wishlistContents && Array.isArray(window.wishlistContents)) {
    const inWishlistSet = new Set();
    window.wishlistContents.forEach(item => {
      if (item.variantId) inWishlistSet.add(String(item.variantId));
      if (item.productId) inWishlistSet.add(String(item.productId));
    });
    
    const isInWishlist = inWishlistSet.has(String(currentVariantId)) || inWishlistSet.has(String(productId));
    
    if (isInWishlist) {
      wishlistButton.classList.add('swym-added');
      wishlistButton.setAttribute('title', 'In wishlist - Click to manage');
      wishlistButton.setAttribute('aria-label', 'Go to wishlist to manage this item');
      wishlistButton.setAttribute('onclick', `removeFromWishlist({ variantId: ${currentVariantId}, productId: ${productId}, url: window.location.href })`);
    } else {
      wishlistButton.classList.remove('swym-added');
      wishlistButton.setAttribute('title', 'Add to wishlist');
      wishlistButton.setAttribute('aria-label', 'Add to wishlist');
    }
  }
};

window.ensureSingleWishlist = (defaultName = 'My Wishlist', callbackFn, errorFn) => {
  window._swat.fetchLists({
    callbackFn: (lists = []) => {
      const ordered = lists.slice().reverse();
      const selected = ordered[0];

      if (!selected) {
        window._swat.createList(
          { lname: defaultName },
          (resp) => {
            const lid = resp?.lid;
            if (lid) window._swat.swymCustomWishlistSelectedListId = lid;
            if (callbackFn) callbackFn({ lid, created: true, renamed: false });
          },
          errorFn || ((err) => console.error('Error creating single wishlist', err))
        );
        return;
      }

      const lid = selected.lid;
      window._swat.swymCustomWishlistSelectedListId = lid;

      if (defaultName && selected.lname && selected.lname !== defaultName) {
        window._swat.updateListDetails(
          { lid, lname: defaultName },
          () => {
            if (callbackFn) callbackFn({ lid, created: false, renamed: true });
          },
          errorFn || ((err) => console.error('Error renaming wishlist', err))
        );
      } else {
        if (callbackFn) callbackFn({ lid, created: false, renamed: false });
      }
    },
    errorFn: errorFn || ((err) => console.error('Error fetching lists', err))
  });
};

window.getSingleWishlistLid = (callbackFn, errorFn, defaultName = 'My Wishlist') => {
  window.ensureSingleWishlist(defaultName, (res) => {
    if (callbackFn) callbackFn(res?.lid);
  }, errorFn);
};

(function () {
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    window.ensureSingleWishlist(DEFAULT_WISHLIST_NAME, function (res) {
      if (res?.lid) {
        window._swat.swymCustomWishlistSelectedListId = res.lid;
        window.fetchWishlistContents(res.lid);
      }
    });
  });

  window.SwymCallbacks.push(function () {
    window._swat.evtLayer.addEventListener('sw:addedtocart', function () {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist' });
    });

    window._swat.evtLayer.addEventListener('sw:addedtolist', function (event) {
      const { epi: variantId, empi: productId } = event.detail || {};
      if (variantId && productId) {
        updateWishlistButtonState(variantId, productId, true);
      }
    });

    window._swat.evtLayer.addEventListener('sw:removedfromlist', function (event) {
      const { epi: variantId, empi: productId } = event.detail || {};
      if (variantId && productId) {
        updateWishlistButtonState(variantId, productId, false);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    const variantInput = document.querySelector('.product-variant-id');
    if (variantInput) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            updateProductFormWishlistButton();
          }
        });
      });
      
      observer.observe(variantInput, { 
        attributes: true, 
        attributeFilter: ['value'] 
      });
      
      variantInput.addEventListener('change', updateProductFormWishlistButton);
    }

    document.addEventListener('react-variant-change', function(event) {
      updateProductFormWishlistButton();
    });
  });
})();